// extracted by mini-css-extract-plugin
module.exports = {"video":"rich-text-renderer_video__EW3UR","rtParagraph":"rich-text-renderer_rtParagraph__3JyCN"};